import React, { useState, useEffect } from 'react';
import styles from './InputArea.module.css';

function InputArea({ onSendMessage, disabled, readOnlyChannel, channelName, prefillMessage }) {
  const [message, setMessage] = useState('');

  // PREFILL message when prop changes (e.g., clicking user for whisper)
  useEffect(() => {
    if (prefillMessage) {
      setMessage(prefillMessage);
    }
  }, [prefillMessage]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!message.trim()) {
      return;
    }

    // SEND message
    onSendMessage(message);

    // CLEAR input
    setMessage('');
  };

  const handleKeyDown = (e) => {
    // SEND on Enter (without Shift)
    // Shift+Enter adds new line for code blocks
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // DETERMINE placeholder based on channel
  const getPlaceholder = () => {
    if (disabled) return 'Verbinde...';
    if (readOnlyChannel && channelName === 'portal') {
      return 'Nur Commands - /join #general zum Starten';
    }
    return 'Nachricht eingeben... (Shift+Enter für neue Zeile, /code für Code Blocks)';
  };

  return (
    <form onSubmit={handleSubmit} className={styles.container}>
      <textarea
        className={styles.input}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={getPlaceholder()}
        disabled={disabled}
        maxLength={2000}
        autoComplete="off"
        rows={1}
      />
      <button
        type="submit"
        className={styles.sendButton}
        disabled={disabled || !message.trim()}
      >
        Senden
      </button>
    </form>
  );
}

export default InputArea;
